<template>
  <div
    :class="`row m-t-none ui-thumbnail-header ui-thumbnail-header-${tamano}`"
  >
    <div class="col-md-12">
      <slot name="previo" />
      <div class="pull-left m-r">
        <img :src="imagen" class="img-responsive img-circle img-thumbnail" />
      </div>
      <div class="inline pull-left">
        <h2 class="title">
          {{ titulo }}
        </h2>
        <small class="text-mute">
          {{ subtitulo }}
          <slot name="subtitulo" />
        </small>
      </div>
    </div>
  </div>
</template>

<script>
// Mismo que el método ui_thumbnail_header de ui_helper. La idea es una imágen a la izquierda
// con el título y subtítulo.
export default {
  props: {
    imagen: { type: String, default: undefined },
    titulo: { type: String, default: '' },
    subtitulo: { type: String, default: undefined },
    tamano: { type: String, default: 'md' },
  },
};
</script>
